import { action, runInAction, makeObservable } from "mobx";
import ConfirmStore from "../../store/ConfirmStore";

class ModalConfirmService {
    abrirModal = () => {
        ConfirmStore.modalAberto = true;
    }

    fecharModal = () => {
        ConfirmStore.modalAberto = false;
        ConfirmStore && ConfirmStore.resolve(false);
    }

    acaoDeConfirmar = () => {
        runInAction(() => {
            ConfirmStore.modalAberto = false;
        });
        ConfirmStore && ConfirmStore.resolve(true);
    }

    aguardarEscolhaDoUsuario = async () => {
        return new Promise((resolve) => {
            ConfirmStore.resolve = resolve;
        })
    }

    constructor() {
        makeObservable(this, {
            abrirModal: action,
            fecharModal: action
        });
    }
}

export default new ModalConfirmService();